/* eslint-disable import/prefer-default-export */

export class HostProvider {
  static getHost = () => {
    const isCaprabo = document.location.hostname.includes('caprabo.com');
    return isCaprabo
      ? `${process.env.REACT_APP_API_CAPRABO}/`
      : `${process.env.REACT_APP_API}/`;
  };

  static isCaprabo = () => {
    return document.location.hostname.includes('caprabo.com');
  };

  static isEroski = () => {
    return document.location.hostname.includes('eroski.es');
  };

  static prepareLevels = (locate = '') => {
    const result: Array<string> = ['', '', ''];
    const lng: string = '/'.concat(locate).concat('/');
    const idx: number = document.location.pathname.lastIndexOf(lng);
    const levels = `${document.location.pathname.substring(idx + lng.length)}/`;
    if (levels.length > 1) {
      levels.split('/').forEach((l, id) => {
        if (l.length > 0) {
          result[id] = l;
        }
      });
    }
    return result;
  };
}
